import {Component, Input, OnInit} from '@angular/core';
import {FormControl, FormGroup} from "@angular/forms";
import {TextUtils} from "../../../../../../shared/utils/text-utils";
import {IDsDropdownOption} from "../../../../../../shared/components/ds-dropdown/ds-dropdown-option";
import {IShippingClass} from "../add-product-form.interface";
import {ProductAddHelperService} from "../product-add-helper.service";

@Component({
    selector: 'db-product-shipping',
    templateUrl: './product-shipping.component.html',
    styleUrls: ['./product-shipping.component.scss'],
    standalone: false
})
export class ProductShippingComponent implements OnInit {
  @Input() shippingForm: FormGroup;
  shippingClassesDropdown: IDsDropdownOption[] = [];

  @Input() set shippingClasses(list: IShippingClass[]) {
    this.shippingClassesDropdown = list.map((shipping => {
      return {
        value: shipping.id,
        label: shipping.name,
        description: shipping.slug
      };
    }));
    this.shippingClassesDropdown.unshift({value: '', label: TextUtils.getText('text_noShippingClass')});
  }

  @Input() measurements = this._productAddHelper.measurements.value;
  @Input() isEdit = false;

  constructor(private _productAddHelper: ProductAddHelperService) {
  }

  get weightTypeFormControl(): FormControl {
    return this.shippingForm.get('weight_type') as FormControl;
  }

  get shippingClassFormControl(): FormControl {
    return this.shippingForm.get('shipping_class_id') as FormControl;
  }

  ngOnInit() {
  }

  changeWeightType(type: string) {
  }

  onShippingChange(value: IDsDropdownOption) {
    if (value.value === '') {
      this.shippingClassFormControl.reset();
      this.shippingClassFormControl.setValue('');
      this.shippingForm.get('shipping_class').setValue('');
      this.shippingClassFormControl.markAsDirty();
      return;
    }
    this.shippingClassFormControl.setValue(value.value);
    this.shippingForm.get('shipping_class').setValue(value.description);
    this.shippingClassFormControl.markAsDirty();
  }
}
